import React from 'react';
import Button, { Props as ButtonProps } from './Button';
import { PlusIcon as Plus } from '@heroicons/react/24/outline';
import styled from '@emotion/styled';
import tw from 'twin.macro';
import Spinner from '@teetsh/app/src/components/Buttons/Spinner';

interface Props {
  leftIcon: any;
}

const StyledIconLeft = styled.div`
  ${tw`h-6 w-6`}
`;

const PButton = tw(Button)`p-2 rounded-full shadow-sm space-x-3 text-left`;

export default function PillButton(props: Props & ButtonProps) {
  const { leftIcon, children, loading, ...rest } = props;
  return (
    <PButton className="group" fill disabled={loading} {...rest}>
      <span tw="min-w-0 flex-1 flex items-center space-x-3 pl-0">
        <span tw="block shrink-0 bg-neutral-quiet rounded-full p-2">
          {leftIcon && !loading && (
            <StyledIconLeft as={props.leftIcon as any} />
          )}
          {loading && <Spinner />}
        </span>
        <span tw="block min-w-0 flex-1">
          <span tw="block text-base font-medium text-neutral-intense truncate">
            {children}
          </span>
        </span>
      </span>
      <span tw="shrink-0 h-10 w-10 inline-flex items-center justify-center">
        <Plus
          tw="h-6 w-6 text-neutral-quiet group-hover:text-neutral-quiet"
          aria-hidden="true"
        />
      </span>
    </PButton>
  );
}
